export default __webpack_public_path__ + "static/media/bg_trial.154b505a.svg";